import React from "react"
import {motion} from "framer-motion"

export default function Checkbox({text, is_checked, set_checked}) {
    return <div className='checkbox-container' onClick={e => set_checked(!is_checked)}>
        <div className='checkbox'>{is_checked&& <motion.i className="fa fa-check" initial={{scale: 0.6}} animate={{scale:1}}/>}</div>
        <div>{text}</div>
    </div>
}